import { IUser } from '@reverbdotcom/commons/dist/components/user_context_provider';
import experiments from '@reverbdotcom/commons/dist/experiments';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';

export function boostedUserCountryCode(user: Partial<IUser>) {
  if (isExperimentEnabled(user, experiments.BOOST_MARKETPLACE_SELLER_LOCATION)) {
    return user.countryCode;
  }

  return '';
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/boosted_user_country_code.ts